import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './audioControl.scss';

class AudioControl extends Component {
  constructor(props, context){
    super(props)
    this.state = {
      currentTime: 0,
      progressWidth: '',
      progressIconLeft: '',
      audioParagraphIndex: '',
      timer: '',
      isPlay: false,
      audio: new Audio
    }
  }
  // 格式化时间
  formatTime(num) {
    if (num === "") return
    var num = parseInt(num, 10);
    if (num <= 60) {
      if (num < 10) {
        num = '00:0' + num;
      } else {
        num = '00:' + num;
      }
    } else if (num < 600 ) {
      num = `0${parseInt(num/60, 10)}:${num%60 >= 10 ? num%60 : '0' + num%60}`
    } else if (num > 600) {
      num = `${parseInt(num/600, 10)}${parseInt((num%600)/60, 10)}: ${(num%600)%60 >= 10 ? (num%600)%60 : '0' + (num%600)%60 }`
    }
    return num;
  }
  onPlay(resetStarts, currentTime) {
    let me = this
    let progressWidth
    let progressIconLeft
    let audioNode = this.state.audio
    if (audioNode.src === '') {
      audioNode.src = this.props.audioSrc
    }
    console.log(audioNode.currentTime)
    audioNode.currentTime = currentTime !== undefined ? currentTime : audioNode.currentTime
    this.setState({
      isPlay: !this.state.isPlay,
      audio: audioNode
    }, function () {
      if (!this.state.isPlay && !resetStarts) {
        audioNode.pause();
        clearInterval(this.timer)
      } else {
        audioNode.play();
        this.timer = setInterval(() => {
          for (let i = 0; i < this.props.articleContact.length; i++) {
            if (this.props.articleContact[i].startTs) {
              if (i + 1 === this.props.articleContact.length) {
                this.setState({
                  audioParagraphIndex: i
                })
              } else if (this.props.articleContact[i].startTs/1000 <= audioNode.currentTime && this.props.articleContact[i + 1].startTs/1000 > audioNode.currentTime) {
                if (this.state.audioParagraphIndex !== i) {
                  this.setState({
                    audioParagraphIndex: i
                  })
                  this.props.changeParagraphhighlight(i)
                }
                break
              }
              if (this.props.articleContact[i].startTs/1000 > audioNode.currentTime) {
                break
              }
            }
          }
          let multiple = audioNode.currentTime / me.props.audioDuration * 5.56
          progressWidth = `${multiple}rem`
          progressIconLeft = `${multiple}rem`
          let progressIcon = document.getElementsByClassName('progress_icon')[0]
          let progressBar = document.getElementsByClassName('progress_bar')[0]
          progressIcon.style.left = progressIconLeft
          progressBar.style.width = progressWidth
          this.setState({
            currentTime: audioNode.currentTime
          })
        }, 1000)
      }
    })
  }
  // 切换当前文章展示的语音
  // 当this.props.hasTrans === true 时，代表当前文章含有译文，所以默认是双语，切换顺序为双语、原文、译文、隐藏
  // 如果不含有译文默认是原文、切换顺序为原文、隐藏
  // index = 0 双语、index = 1原文、index = 2译文、index =3隐藏
  rePlay(startTs) {
    // 控制音频播放的currentTime
    // let audio = ReactDOM.findDOMNode(this.refs.audio);
    
    let audio = this.state.audio
    // audio.src = this.props.audioSrc
    let currentTime = startTs / 1000
    clearInterval(this.timer)
    if (this.state.isPlay) {
      this.setState({
        isPlay: !this.state.isPlay,
        audio: audio
      }, function() {
        this.onPlay(true, currentTime)
      })
    } else {
      this.onPlay(true, currentTime)
    }
  }
  // 打开有道词典app
  openDict() {
    window.location.href = 'http://cidian.youdao.com/m/d'
  }
  // 计算点击进度条的位置距离
  timelineClick(e) {
    if (this.props.vip) return
    let progressWidth
    let progressIconLeft
    let startTs
    let audioNode = this.state.audio
    let progressIcon = ReactDOM.findDOMNode(this.refs.progressIcon)
    let timeline = ReactDOM.findDOMNode(this.refs.timeline)
    let progressBarWidth = getComputedStyle(timeline).width
    let progressleft = getComputedStyle(timeline).left
    let progressIconWidth = getComputedStyle(progressIcon).width
    progressWidth = `${e.pageX-parseInt(progressleft, 10)}px`
    progressIconLeft = `${e.pageX-parseInt(progressleft, 10) - parseInt(progressIconWidth, 10)/2}px`
    let progressBar = document.getElementsByClassName('progress_bar')[0]
    progressIcon.style.left = progressIconLeft
    progressBar.style.width = progressWidth
    startTs = parseInt(progressWidth, 10) / parseInt(progressBarWidth, 10) * this.props.audioDuration
    clearInterval(this.timer)
    if (this.state.isPlay) {
      this.setState({
        isPlay: !this.state.isPlay,
      }, function() {
        this.onPlay(true, startTs)
      })
    } else {
      this.onPlay(true, startTs)
    }
  }
  progressTouchMove() {
    let that = this
    let progress = ReactDOM.findDOMNode(this.refs.progressIcon)
    let timeline = ReactDOM.findDOMNode(this.refs.timeline)
    let progressBarWidth = getComputedStyle(timeline).width // 获取进度条的宽度
    let progressleft = getComputedStyle(timeline).left /// 获取进度条上圆圈的定位的left
    let progressIconWidth = getComputedStyle(progress).width // 获取进度条上圆圈的宽度
    progress.addEventListener("touchstart",handleStart,false);
    progress.addEventListener("touchmove",handleMove,false);
    progress.addEventListener("touchend",handleEnd,false);
    function handleStart(e) {
      e.preventDefault();
      if (that.props.vip) return
      // 触发touchstart 需要清除定时器，防止在拖拽过程中还在计算进度条的进度
      clearInterval(that.timer)
    }
    function handleMove(e) {
      e.preventDefault();
      if (that.props.vip) return
      // 触发touchstart 需要清除定时器，防止在拖拽过程中还在计算进度条的进度
      clearInterval(that.timer)
      // 计算进度条移动的位置距离
      let progressIconLeft = `${parseInt(e.changedTouches[0].pageX, 10) - parseInt(progressleft, 10)}px`
      let progressWidth = `${parseInt(e.changedTouches[0].pageX, 10) - parseInt(progressleft, 10) + parseInt(progressIconWidth, 10)/2}px`
      let progressBar = document.getElementsByClassName('progress_bar')[0]
      if (parseInt(progressIconLeft, 10) <= 0 || parseInt(progressWidth, 10) <= 0) {
        progress.style.left = 0
        progressBar.style.width = 0
      } else if (parseInt(progressIconLeft, 10) >= parseInt(progressBarWidth, 10) || parseInt(progressWidth, 10) >= parseInt(progressBarWidth, 10)) {
        progress.style.left = progressBarWidth
        progressBar.style.width = progressBarWidth
      } else {
        progress.style.left = progressIconLeft
        progressBar.style.width = progressWidth
      }
    }
    function handleEnd(e){
      e.preventDefault();
      if (that.props.vip) return
      let startTs
      let progressWidth = parseInt(e.changedTouches[0].pageX, 10) - parseInt(progressleft, 10) + parseInt(progressIconWidth, 10) / 2
      startTs = parseInt(progressWidth, 10) / parseInt(progressBarWidth, 10) * that.props.audioDuration
      clearInterval(that.timer)
      if (that.state.isPlay) {
        that.setState({
          isPlay: !that.state.isPlay
        }, function() {
          that.onPlay(true, startTs)
        })
      } else {
        that.onPlay(true, startTs)
      }
    }
  }
  render() {
    setTimeout(()=> {
      this.progressTouchMove()
    }, 1000)
    return (
      <div className="audio_control">
        <div className="open_dict" onClick={()=> this.openDict()}>
          <a>打开有道词典，查看全文字幕</a>
        </div>
        <div className="control">
          <div className="time_bar">
            <p className="start">{this.formatTime(Math.round(this.state.currentTime))}</p>
            <p className="end">{this.formatTime(this.props.audioDuration)}</p>
            <div className="progress" onClick={(event) => this.timelineClick(event)} ref="timeline">
              <div className="progress_icon" ref="progressIcon"></div>
              <div className="progress_bar"></div>
            </div>
            {/* <audio ref="audio" src={this.props.audioSrc}  preload="metadata" controls></audio> */}
          </div>
          <div className="control_bar">
            <img className="article_status" src={this.props.articlelanguage} onClick={() => this.props.changeArticleLanguage()}/>
            {/* 上一个 */}
            <img src="http://ydschool-online.nos.netease.com/1573553160724ic_audio_article_control_prev%402x.png" />
            {
              !this.props.vip && (this.state.isPlay ? <img alt="播放中" src="http://ydschool-online.nos.netease.com/1572867094464ic_audio_article_control_pause%402x.png" onClick={() => this.onPlay(false)} /> : <img src = "http://ydschool-online.nos.netease.com/1573116021650ic_audio_article_control_play%402x.png" alt="暂停" onClick={() => this.onPlay(false)}/>)
            }
            {
              this.props.vip &&  <img src = "http://ydschool-online.nos.netease.com/1574395242649ic_audio_article_control_play_disable.png" alt="不可播放" />
            }
            {/* 下一个 */}
            <img src="http://ydschool-online.nos.netease.com/1573553188522ic_audio_article_control_next%402x.png" />
            {/* 列表 */}
            <img className="article_list" src="http://ydschool-online.nos.netease.com/1572867614569ic_audio_article_control_menu%402x.png" />
          </div>
        </div>
      </div>
    );
  }
}

export default AudioControl;
